module.exports = __webpack_public_path__ + "45f0aa7dd5a29ecf0872bae22d250dd9.png";


//////////////////
// WEBPACK FOOTER
// ./client/images/illustrations/podcasters-spread-app.png
// module id = EqVt
// module chunks = 15